export const queryKeys = {
    getInvalidEmployee: "getInvalidEmployee",
  };